<template>
  <header
    class="sticky top-0 z-50 transition-all duration-300"
    :class="
      scrolled
        ? 'border-b border-gray-100 bg-secondary-light/80 backdrop-blur dark:border-white/5 dark:bg-primary-dark/80'
        : 'border-b border-transparent'
    "
  >
    <div class="container mx-auto flex items-center justify-between px-6 py-4">
      <div class="flex items-center gap-3">
        <a href="#top" class="group inline-flex items-center gap-2.5" aria-label="Back to top">
          <span
            class="grid h-9 w-9 place-items-center rounded-xl bg-jelly-500 font-general-bold text-white transition-transform duration-300 group-hover:rotate-6"
          >
            KA
          </span>
          <span class="font-general-semibold text-primary-dark dark:text-primary-light">
            {{ profile.name }}
          </span>
        </a>

        <div v-if="scrolled" class="hidden items-center gap-2.5 sm:flex" aria-hidden="true">
          <span class="tag-divider"></span>
          <span class="tag-word">
            <span
              v-for="(ch, i) in portfolio"
              :key="i"
              class="tag-letter"
              :style="{ animationDelay: `${0.22 + i * 0.035}s` }"
              >{{ ch }}</span
            >
          </span>
        </div>
      </div>
      <ThemeToggle />
    </div>
  </header>
</template>

<script setup>
import ThemeToggle from '@/components/base/ThemeToggle.vue';
import { useScrolledPast } from '@/composables/useScrolledPast';
import { profile } from '@/constants/profile';

const scrolled = useScrolledPast(24);
const portfolio = [...'Portfolio'];
</script>

<style scoped lang="scss">
.tag-divider {
  @apply bg-gray-300 dark:bg-white/15;

  animation: tag-divider 0.45s cubic-bezier(0.2, 0.85, 0.3, 1) both;
  height: 1.2rem;
  width: 1px;
}

@keyframes tag-divider {
  0% {
    opacity: 0;
    transform: translateY(-0.8rem);
  }

  70% {
    opacity: 1;
    transform: translateY(0.12rem);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.tag-word {
  @apply text-gray-400;

  display: inline-flex;
  font-family: GeneralSans-Medium, sans-serif;
  font-size: 0.9rem;
}

.tag-letter {
  animation: tag-letter 0.4s cubic-bezier(0.2, 0.8, 0.2, 1) both;
  display: inline-block;
  white-space: pre;
}

@keyframes tag-letter {
  from {
    opacity: 0;
    transform: translateX(0.6rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .tag-divider,
  .tag-letter {
    animation: none;
  }
}
</style>
